module.exports = __webpack_public_path__ + "img/logo2@2x.48358c18.png";